/**
 * TanStack Query hooks for `agency-dashboard-aggregating-all-client-performance`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	agencyDashboardAggregatingAllClientPerformanceQueryKeys,
	type CreateAgencyDashboardAggregatingAllClientPerformanceBody,
	type ListAgencyDashboardAggregatingAllClientPerformanceResponse,
	type AgencyDashboardAggregatingAllClientPerformanceRow,
} from "./api";

export function useAgencyDashboardAggregatingAllClientPerformanceList(): UseQueryResult<ListAgencyDashboardAggregatingAllClientPerformanceResponse, Error> {
	return useQuery({
		queryKey: agencyDashboardAggregatingAllClientPerformanceQueryKeys.list(),
		queryFn: list,
	});
}

export function useAgencyDashboardAggregatingAllClientPerformanceCreate(): UseMutationResult<AgencyDashboardAggregatingAllClientPerformanceRow, Error, CreateAgencyDashboardAggregatingAllClientPerformanceBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyDashboardAggregatingAllClientPerformanceQueryKeys.all });
		},
	});
}

export function useAgencyDashboardAggregatingAllClientPerformanceDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyDashboardAggregatingAllClientPerformanceQueryKeys.all });
		},
	});
}
